import type {Repository} from '@github-ui/current-repository'
import {NewAgentTaskForm} from '@github-ui/new-agent-task-form/NewAgentTaskForm'
import {TOGGLE_COPILOT_OVERLAY} from '@github-ui/global-agents-menu/GlobalAgentsMenu'
import {useCreateTask} from '@github-ui/agent-sessions/hooks/useCreateTask'
import {useTasks} from '@github-ui/agent-sessions/hooks/useTasks'
import {ConsecutiveCAPI401sProvider} from '@github-ui/agent-sessions/contexts/ConsecutiveCAPI401sContext'
import type {CreateTaskReference} from '@github-ui/agent-sessions/components/NewTaskChatInput'

type NewAgentTaskButtonContentProps = {
  currentRepo?: Repository
  currentReference?: CreateTaskReference
  hideRepoSelector?: boolean
  setOpen: (open: boolean) => void
  eventType: string
}

export function NewAgentTaskButtonContent(props: NewAgentTaskButtonContentProps) {
  return (
    <ConsecutiveCAPI401sProvider>
      <InnerNewAgentTaskButtonContent {...props} />
    </ConsecutiveCAPI401sProvider>
  )
}

export function InnerNewAgentTaskButtonContent({
  currentRepo,
  currentReference,
  hideRepoSelector,
  setOpen,
  eventType,
}: NewAgentTaskButtonContentProps) {
  // Warm up the cache by prefetching tasks
  // TODO: Consider using something inside useCreateTask to prefetch tasks instead
  // e.g await queryClient.refetchQueries({ queryKey: ['posts'], type: 'active' })
  useTasks({sessionsPollingInterval: false})
  const {createTask} = useCreateTask({})

  return (
    <NewAgentTaskForm
      createTask={createTask}
      currentRepo={currentRepo}
      currentReference={currentReference}
      onCreate={() => {
        setOpen(false)
        document.dispatchEvent(new CustomEvent(TOGGLE_COPILOT_OVERLAY))
      }}
      hideRepoSelector={hideRepoSelector}
      eventType={eventType}
    />
  )
}

try{ NewAgentTaskButtonContent.displayName ||= 'NewAgentTaskButtonContent' } catch {}
try{ InnerNewAgentTaskButtonContent.displayName ||= 'InnerNewAgentTaskButtonContent' } catch {}